import { Skill, SyncedUser, isRepositoryManagedSkill } from './fes';

export type Session = {
  userId: string;
  email?: string;
  isAdmin: boolean;
  teamIds: string[];
  activeTeamId?: string;
};

export function toSession(user: SyncedUser): Session {
  const isAdmin = user.roles.includes('admin');

  return {
    userId: user.userId,
    ...(user.email ? { email: user.email } : {}),
    isAdmin,
    teamIds: user.teamIds,
    activeTeamId: user.teamIds.length === 1 ? user.teamIds[0] : undefined,
  };
}

export function hasNoTeam(session: Session): boolean {
  return !session.isAdmin && session.teamIds.length === 0;
}

export function canEditSkill(skill: Pick<Skill, 'managedBy' | 'teamId'>, session: Session): boolean {
  if (isRepositoryManagedSkill(skill)) {
    return false;
  }

  if (!skill.teamId) {
    return session.isAdmin;
  }

  return session.isAdmin || session.teamIds.includes(skill.teamId);
}
